import React from "react";
import {
    TabList,
    Tab,
    makeStyles,
    tokens,
    Toaster,
} from "@fluentui/react-components";
import TenantsTable from './AdminTable/TenantsTable'
import AdminTopbar from "./AdminTopbar";
import CallRecordSubscriptionButton from "./CallRecordSubscription"
import UnifySyncApprove from "./UnifySyncApprove"
import { useSearchParams } from "react-router";

const useStyles = makeStyles({
    container: {
        backgroundColor: tokens.colorNeutralBackground1,
        border: `1px solid ${tokens.colorNeutralStroke2}`,
        borderRadius: tokens.borderRadiusLarge,
        padding: "16px",
        marginBottom: "16px",
    },
    section: {
        marginTop: "8px",
        padding: "10px"
    },
    row: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "12px",
        border: `1px solid ${tokens.colorNeutralStroke2}`,
        borderRadius: tokens.borderRadiusMedium,
        marginBottom: "12px",
        backgroundColor: tokens.colorNeutralBackground2,
    },
    topbar: {
        gridColumn: '2',
        gridRow: '1',
        display: 'flex',
        alignItems: 'center',
        borderBottom: `1px solid ${tokens.colorNeutralStroke2}`,
        backgroundColor: tokens.colorNeutralBackground1,
    },
});

const VALID_TABS = ["microsoft", "salesforce"];
const DEFAULT_TAB = "microsoft";

export default function Authorization() {
    const styles = useStyles();
    const [searchParams, setSearchParams] = useSearchParams();
    // const [selectedTab, setSelectedTab] = useState("microsoft");

    const tabParam = searchParams.get("tab") || DEFAULT_TAB;
    const selectedTab = VALID_TABS.includes(tabParam) ? tabParam : DEFAULT_TAB;

    const toasterId = "auth-toaster";

    React.useEffect(() => {
        if (tabParam !== selectedTab) {
            // eslint-disable-next-line no-undef
            const next = new URLSearchParams(searchParams);
            next.set("tab", selectedTab);
            setSearchParams(next, { replace: true });
        }
    }, [tabParam, selectedTab]);

    const handleTabSelect = (_, data) => {
        const next = data.value;
        if (next !== selectedTab) {
            // eslint-disable-next-line no-undef
            const sp = new URLSearchParams();
            sp.set("tab", next);
            setSearchParams(sp);
        }
    };

    return (
        <>
            <Toaster toasterId={toasterId} />
            <header className={styles.topbar}>
                <AdminTopbar title={"Authorization"} />
            </header>

            <TabList
                selectedValue={selectedTab}
                onTabSelect={handleTabSelect}
            >
                <Tab value="microsoft">Microsoft</Tab>
                <Tab value="salesforce">Salesforce</Tab>
            </TabList>

            <div className={styles.section}>
                {selectedTab === "microsoft" && (
                    <>
                        <UnifySyncApprove />
                        <CallRecordSubscriptionButton />
                    </>
                )}

                {selectedTab === "salesforce" && (
                    <TenantsTable />
                )}
            </div>
        </>
    );
}